import { memo } from 'react';

import { BUILDER_ROW_TYPES } from '../../../../../../constants/campaignBuilder.js';
import { Columns } from '../../../../../../constants/myCampaigns.js';
import { BuilderTableColumn, BuilderTableRow } from '../../../../types.js';
import FormattedField from '../FormattedField/FormattedField.jsx';

export type Props = {
  value: string | number | null;
  column: BuilderTableColumn;
  row: BuilderTableRow;
  cellColor: string;
};

const NumberField = memo(({ value, column, row, cellColor }: Props) => {
  const { type, scale } = row.original;
  const isTileRow = type === BUILDER_ROW_TYPES.TILE;
  const isEstCo2 = column.id === Columns.CO2;

  const prefix = isEstCo2 ? 'Kg ' : '';

  // hide zero value for every row but the media row level
  const isEmptyValueHidden =
    !Number(value) && !!column.hideEmptyValueForReadOnlyRowLevel && !isTileRow;

  return (
    <FormattedField
      scale={scale}
      value={value}
      decimalLimit={column.decimals}
      isEmptyValueHidden={isEmptyValueHidden}
      color={cellColor}
      prefix={prefix}
      variant="number"
    />
  );
});
export default NumberField;
